import { confirmSchema, magicLinkSchema, meSchema } from "@/api/http/schemas/authSchemas";
import { BaseHttpService, validateWithSchema } from "@/api/http/BaseHttpService";
import type {
  ConfirmResponse,
  MagicLinkResponse,
  MeResponse,
} from "@/api/http/schemas/authSchemas";
import config from "@/config";

export const authEndpoints = {
  magicLink: "borrower_platform/auth/magic_link",
  confirm: "borrower_platform/auth/confirm",
  me: "borrower_platform/auth/me",
  authorizeBroadcasting: "broadcasting/auth",
  login: "borrower_platform/auth/login",
  widgetHandoff: "borrower_platform/auth/widget_handoff",
} as const;

export class AuthHttpService extends BaseHttpService {
  screenLoadingPaths = [
    authEndpoints.magicLink,
    authEndpoints.confirm,
    authEndpoints.me,
    authEndpoints.login,
    authEndpoints.widgetHandoff,
  ];

  async createMagicLink(email: string) {
    const payload: Record<string, string> = { email };
    const { emailBranding: emailBrandingId, branding: brandingId } = config;

    if (emailBrandingId) {
      payload.email_branding_id = emailBrandingId;
    }
    if (brandingId) {
      payload.branding_id = brandingId;
    }

    const { data } = await this.post<{ data: MagicLinkResponse }>(authEndpoints.magicLink, payload);
    return validateWithSchema(magicLinkSchema, data);
  }

  async confirmAuth(payload: { email: string; code: string }) {
    const { data } = await this.post<{ data: ConfirmResponse }>(authEndpoints.confirm, payload);
    return validateWithSchema(confirmSchema, data);
  }

  async getMe() {
    const { data } = await this.get<{ data: MeResponse }>(authEndpoints.me);
    return validateWithSchema(meSchema, data);
  }

  async authorizeBroadcast(payload: { socket_id: string; channel_name: string }) {
    return await this.post<string>(authEndpoints.authorizeBroadcasting, payload);
  }

  async loginWithSecret(payload: { email: string; secret: string }) {
    const { data } = await this.post<{ data: ConfirmResponse }>(authEndpoints.login, payload);
    return validateWithSchema(confirmSchema, data);
  }

  async redeemWidgetHandoff(payload: { code: string }) {
    const { data } = await this.post<{ data: ConfirmResponse }>(
      authEndpoints.widgetHandoff,
      payload
    );
    return validateWithSchema(confirmSchema, data);
  }
}
